import {Injectable} from '@angular/core';
import {CustomerProfile} from '../domain/customer/customer-profile';
import {AccountService} from './account.service';
import {Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {LocalStorageService} from 'angular-2-local-storage';
import {StorageItem} from '../enums/storage-item';
import {ReplaySubject} from 'rxjs';
import {MediaAccessStatus} from '../domain/accounts/media-access';

@Injectable({
  providedIn: 'root'
})
export class CustomerProfileService {
  customerProfile: CustomerProfile;
  private customerProfileSubject = new ReplaySubject<CustomerProfile>(1);
  customerProfile$ = this.customerProfileSubject.asObservable();
  eMediaAccessStatus = MediaAccessStatus;
  constructor(
    private router: Router,
    private accountService: AccountService,
    private localStorage: LocalStorageService
  ) {
  }

  clearCustomerProfile() {
    this.customerProfile = null;
    this.customerProfileSubject = new ReplaySubject<CustomerProfile>(1);
    this.customerProfile$ = this.customerProfileSubject.asObservable();
  }
  /**
   * Manda un nuevo valor a los subscritos a customerProfile$ si customerProfile no existe todavía
   *
   */
  getInstance(refresh = false) {
    if (this.customerProfile && !refresh){
      return;
    }
    this.accountService.getProfile().pipe(
      map(
        (response: any) => {
          this.customerProfile = response;
          if (this.customerProfile.mediaAccessStatus === this.eMediaAccessStatus.CANCELED){
            this.customerProfile.mediaAccessStatus = this.eMediaAccessStatus.CANCELLED;
          }
          this.customerProfile.fullName = this.fullName;
          this.customerProfile.cardName = this.cardName;

          let welcomeName = this.customerProfile.lastName;
          if (!this.customerProfile.pronoun) {
            welcomeName = `${this.customerProfile.firstName} ${welcomeName}`;
          }
          this.localStorage.set(StorageItem.USER_INFORMATION, welcomeName);
          this.localStorage.set(StorageItem.TITLE, this.customerProfile.pronoun);
          return this.customerProfile;
        }
      )
    ).subscribe(customerProfile => this.customerProfileSubject.next(customerProfile),
      error => this.customerProfileSubject.next(error));
  }

  logOut() {
    if (this.customerProfile) {
      this.customerProfile = null;
    }
    this.customerProfileSubject = new ReplaySubject<CustomerProfile>(1);
    this.customerProfile$ = this.customerProfileSubject.asObservable();
  }
  // fixme validar los campos nulos
  get fullName(): string {
    return [this.customerProfile.firstName,
      this.customerProfile.middleName, this.customerProfile.lastName, this.customerProfile.secondLastName].filter(String).join(' ');
  }

  get cardName(): string {
    return [this.customerProfile.firstName, this.customerProfile.lastName].filter(String).join(' ');
  }

  getPinAvailable(){
    return this.customerProfile?.pinAvailable;
  }

}
